module.exports = __webpack_public_path__ + "eb5a95615c7e1a1ce71ef254f25b337b.pdf";